import { render } from "./NewReferralForm.vue?vue&type=template&id=81796be2"
import script from "./NewReferralForm.vue?vue&type=script&lang=js"
export * from "./NewReferralForm.vue?vue&type=script&lang=js"

import "./NewReferralForm.vue?vue&type=style&index=0&id=81796be2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__